import { StepDTO, StoryDTO, UserProgressDTO } from "../api/Api";
import { API } from "../config/api";
import { storiesMock } from "../mocks/stories_mock";
import { Story } from "../view-models/story";

class StoryService {
  async getStories() {
    try {
      let res = API.api.getAllStories();
      let result = (await res).data as StoryDTO[];
      return (
        result
          .map(
            (item: StoryDTO) =>
              new Story(
                item.id || -1,
                item.title || "",
                item.isBlock || true,
                item.mainImageUrl || "",
                item.firstStepId || -1
              )
          )
          .concat(storiesMock) || []
      );
    } catch (err: any) {
      console.error(err);
      return [];
    }
  }

  async getStep(id: number) {
    try {
      let res = API.api.getStep(id);
      let result = (await res).data as StepDTO;
      return result;
    } catch (err: any) {
      console.error(err);
      return {};
    }
  }

  async getStory(id: number) {
    try {
      let res = API.api.getStory(id);
      let result = (await res).data as StoryDTO;
      return result;
    } catch (err: any) {
      console.error(err);
      return {};
    }
  }

  async getStepByBookmark(idStory: number) {
    try {
      let res = API.api.getUserProgress({ storyId: idStory });
      let result = (await res).data as UserProgressDTO;
      return result.stepId || -1;
    } catch (err: any) {
      console.error(err);
      return undefined;
    }
  }
}

export const storyService: StoryService = new StoryService();
